export default __webpack_public_path__ + "static/media/asterisk.d894f1b9.svg";